import L from 'leaflet';
import { useRef } from 'react';
import { enableEsriCredit, showEsriCredit } from './mapCredit';

const ESRI_IMAGERY_URL = (key: string) =>
  `https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=${key}`;
const ESRI_LABELS_URL = (key: string) =>
  `https://static-map-tiles-api.arcgis.com/arcgis/rest/services/static-basemap-tiles-service/v1/arcgis/imagery/labels/static/tile/{z}/{y}/{x}?token=${key}`;

export const useInitializeMap = () => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<L.Map | null>(null);

  const initializeMap = () => {
    const map = L.map(mapRef.current!, {
      attributionControl: false,
      preferCanvas: true,
      zoomControl: false,
      fadeAnimation: false,
    });
    mapInstanceRef.current = map;

    map.attributionControl = L.control.attribution({ prefix: false }).addTo(map);
    const imageryUrl = ESRI_IMAGERY_URL(EsriApiKey);
    const labelsUrl = ESRI_LABELS_URL(EsriApiKey);
    const imagery = L.tileLayer(imageryUrl, { opacity: 1 });
    const labels = L.tileLayer(labelsUrl, { tileSize: 512, zoomOffset: -1 });
    showEsriCredit({ layer: imagery, url: imageryUrl }, { layer: labels, url: labelsUrl });
    imagery.addTo(map);
    labels.addTo(map);
    enableEsriCredit(map);
  };

  return {
    initializeMap,
    mapInstanceRef,
    mapRef,
  };
};
